import TopBar from "../common/TopBar";
import MainContent from "./children/MainContent";
import { usePreEnrollmentCustom } from "./usePreEnrollmentCustom";
import "./PreEnrollmentCustom.scss";

/**
 * Pre-enrollment custom list screen — presentational shell delegating state to
 * {@link usePreEnrollmentCustom}.
 *
 * @returns {import('react').JSX.Element}
 */
const PreEnrollmentCustom = () => {
    const {
        searchCriteria,
        setSearchCriteria,
        visibleCustomSites,
        appliedSearchCriteria,
        sortedField,
        isSortDescending,
        handleSort,
        isLoading,
        isError,
        loadErrorMessage,
    } = usePreEnrollmentCustom();

    const customSitesForTable =
        isLoading || isError ? [] : visibleCustomSites;

    return (
        <div className="pre-enrollment-custom-page">
            <TopBar variant="list">
                <TopBar.Search
                    value={searchCriteria}
                    onChange={setSearchCriteria}
                    placeholder="Search client"
                    ariaLabel="Search client"
                />
            </TopBar>

            {isLoading && (
                <p className="pre-enrollment-custom-page__loading" role="status">
                    Loading custom sites...
                </p>
            )}

            {isError && (
                <p className="pre-enrollment-custom-page__error" role="alert">
                    {loadErrorMessage}
                </p>
            )}

            <MainContent
                customSites={customSitesForTable}
                searchCriteria={appliedSearchCriteria}
                sortedField={sortedField}
                isSortDescending={isSortDescending}
                onSort={handleSort}
            />
        </div>
    );
};

export default PreEnrollmentCustom;
